import { Component, computed, inject, input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Kanban, PhaseFormField } from '../../../../_services/kanban/kanban.model'
import { KanbanService } from '../../kanban.service'

type PhaseSubmissionDisplay = {
  phaseId: string
  phaseName: string
  fields: PhaseFormField[]
  submission: Kanban.Card.Form.PhaseFormSubmission | null
}

@Component({
  selector: 'app-card-form-submissions',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './card-form-submissions.component.html',
  styleUrl: './card-form-submissions.component.scss'
})
export class CardFormSubmissionsComponent {
  private kanbanService = inject(KanbanService)

  card = input.required<Kanban.Card.Entity>()

  phaseSubmissions = computed<PhaseSubmissionDisplay[]>(() => {
    const board = this.kanbanService.board()
    const card = this.card()
    if (!board) return []

    return board.phases
      .filter(phase => phase.formSchema && phase.formSchema.length > 0)
      .map(phase => ({
        phaseId: phase.id,
        phaseName: phase.name,
        fields: phase.formSchema!,
        submission: card.phaseFormSubmissions?.[phase.id] ?? null
      }))
  })

  getDisplayValue(field: PhaseFormField, value: unknown): string {
    if (value === null || value === undefined) return 'N/A'

    switch (field.type) {
      case 'boolean':
        return value ? 'Sim' : 'Não'
      case 'select': {
        const option = field.options?.find(o => o.value === value)
        return option?.label ?? String(value)
      }
      case 'multiselect': {
        const values = value as string[]
        if (!values.length) return 'N/A'
        return values
          .map(v => field.options?.find(o => o.value === v)?.label ?? v)
          .join(', ')
      }
      default:
        return String(value)
    }
  }
}
